import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import BackIcon from "assets/icons/back.svg?react";
import ArrowLeftIcon from "assets/icons/arrow_l.svg?react";
import settingService from "api/settingsService";
import Input from "components/Input";
import HollowButton from "components/HollowButton";
import Button from "components/Button";
import { getErrorMessage } from "utils/getErrorMessage";
import { useTranslation } from "react-i18next";

const ChangePassword: FC<Props> = ({ onCanceled, onSaved }) => {
  const { t } = useTranslation();
  const [passwords, setPasswords] = useState({
    currentPass: "",
    newPass: "",
    newPassRepeat: "",
  });
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { mutate: updatePassword } = settingService.useSetPassword();

  const save = () => {
    updatePassword(
      {
        OldPassword: passwords.currentPass,
        NewPassword: passwords.newPass,
        RepeatPassword: passwords.newPassRepeat,
      },
      {
        onSuccess() {
          onSaved();
        },
        onError(e: any) {
          setError(getErrorMessage(e.response.data));
        },
      }
    );
  };

  useEffect(() => {
    if (
      passwords.currentPass.length === 0 ||
      passwords.newPass.length < 8 ||
      passwords.newPassRepeat.length < 8
    ) {
      setIsValid(false);
      setError(null);
      return;
    }

    if (passwords.newPass !== passwords.newPassRepeat) {
      setIsValid(false);
      setError(t("settings.passwordsDontMatch"));
      return;
    }

    setIsValid(true);
    setError(null);
  }, [passwords.currentPass, passwords.newPass, passwords.newPassRepeat]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pathBar}>
        <div className={styles.backButton}>
          <BackIcon onClick={onCanceled}></BackIcon>
        </div>
        {t("changePassword.basicData")} <ArrowLeftIcon></ArrowLeftIcon> {t("changePassword.changePassword")}
      </div>

      <div className={styles.hint}>
        {t("settings.changePasswordDescription")}
      </div>
      <div className={styles.formWrapper}>
        <div className={styles.form}>
          <Input
            type="password"
            label={t("auth.currentPassword")}
            onChange={(v) => setPasswords({ ...passwords, currentPass: v })}
            value={passwords.currentPass}
            name="currentPassword"
          ></Input>
          <div className={styles.group}>
            <Input
              type="password"
              label={t("auth.newPassword")}
              onChange={(v) => setPasswords({ ...passwords, newPass: v })}
              value={passwords.newPass}
              name="newPassword"
            ></Input>
            <Input
              type="password"
              label={t("auth.repeatPassword")}
              onChange={(v) => setPasswords({ ...passwords, newPassRepeat: v })}
              value={passwords.newPassRepeat}
              name="newPassword"
            ></Input>
            {error && <div className={styles.warn}>{error}</div>}
          </div>
        </div>
      </div>
      <div className={styles.buttons}>
        <HollowButton text={t("common.cancel")} onClick={onCanceled}></HollowButton>
        <Button text={t("common.save")} onClick={save} disabled={!isValid}></Button>
      </div>
    </div>
  );
};

export default ChangePassword;
